// extracted by mini-css-extract-plugin
export default {"dashboardBox":"Dashboard_dashboardBox__B6GdO","dashboardContent":"Dashboard_dashboardContent__xkjzw","dashboardBoxContent":"Dashboard_dashboardBoxContent__q-2nJ"};